import { ProductIconsNames, ProductsIds } from './types';

export function getRequestProductIconName(
  productId: number,
): ProductIconsNames {
  switch (productId) {
    case ProductsIds.Obd2:
      return ProductIconsNames.Obd2;
    case ProductsIds.InvisDuos:
      return ProductIconsNames.InvisDuos;
    case ProductsIds.InvisDuosS:
      return ProductIconsNames.InvisDuosS;
    case ProductsIds.InvisDuos3DL:
      return ProductIconsNames.InvisDuos3DL;
    case ProductsIds.OnlineSlim:
      return ProductIconsNames.OnlineSlim;
    case ProductsIds.InvisDuosContainerTracker:
      return ProductIconsNames.InvisDuosContainerTracker;
    case ProductsIds.OutcallService:
      return ProductIconsNames.OutcallService;
    case ProductsIds.EquipmentInstallation:
      return ProductIconsNames.EquipmentInstallation;
    case ProductsIds.LSAcceptanceAndTransfer:
      return ProductIconsNames.LSAcceptanceAndTransfer;
    case ProductsIds.EquipmentAcceptanceAndTransfer:
      return ProductIconsNames.EquipmentAcceptanceAndTransfer;
    case ProductsIds.Signing:
      return ProductIconsNames.Signing;
    case ProductsIds.ActsSigning:
      return ProductIconsNames.ActsSigning;
    case ProductsIds.Inspection:
      return ProductIconsNames.Inspection;
    case ProductsIds.InspectionWithBooster:
      return ProductIconsNames.InspectionWithBooster;
    case ProductsIds.FuelCardsTransfer:
      return ProductIconsNames.FuelCardsTransfer;
    case ProductsIds.Marking:
      return ProductIconsNames.Marking;
    case ProductsIds.PassengerVehiclePreparation:
      return ProductIconsNames.PassengerVehiclePreparation;
    case ProductsIds.CargoVehiclePreparation:
      return ProductIconsNames.CargoVehiclePreparation;
    case ProductsIds.LSDemonstration:
      return ProductIconsNames.LSDemonstration;
    case ProductsIds.LSDemonstrationWithBooster:
      return ProductIconsNames.LSDemonstrationWithBooster;
    case ProductsIds.AntivandalProtectiveCase:
      return ProductIconsNames.AntivandalProtectiveCase;
    case ProductsIds.Magnet20x3:
      return ProductIconsNames.Magnet20x3;
    case ProductsIds.MonitoringWithEngineBlock:
      return ProductIconsNames.MonitoringWithEngineBlock;
    case ProductsIds.MonitoringWithoutEngineBlock:
      return ProductIconsNames.MonitoringWithoutEngineBlock;
    case ProductsIds.OnlineSpace:
      return ProductIconsNames.OnlineSpace;
    case ProductsIds.OnlineSpacePro:
      return ProductIconsNames.OnlineSpacePro;
    case ProductsIds.GiftSet:
      return ProductIconsNames.GiftSet;
    case ProductsIds.VehicleInspectionAndSigningDkp:
    case ProductsIds.VehicleInspectionAndSigningDkpStock:
      return ProductIconsNames.VehicleInspectionAndSigningDkp;
    case ProductsIds.WarrantyOutcallM1:
    case ProductsIds.WarrantyOutcall:
    case ProductsIds.WarrantyOutcallM2:
    case ProductsIds.WarrantyOutcallM3:
    case ProductsIds.WarrantyOutcallM4:
    case ProductsIds.WarrantyOutcallM5:
    case ProductsIds.WarrantyOutcallSubsequent:
      return ProductIconsNames.WarrantyOutcall;
    case ProductsIds.LSAcceptanceWithoutPts:
      return ProductIconsNames.LSAcceptanceWithoutPts;
    case ProductsIds.VehicleTransferFl:
    case ProductsIds.VehicleTransferStock:
      return ProductIconsNames.VehicleTransfer;
    case ProductsIds.VehicleInspectionAndTransferYulIp:
      return ProductIconsNames.VehicleInspectionAndTransfer;
    case ProductsIds.VehicleInspectionSigningAndTransfer:
      return ProductIconsNames.VehicleInspectionSigningAndTransfer;
    case ProductsIds.VehicleInspectionSigningAndTransferCancellation:
    case ProductsIds.VehicleTransferFlCancellation:
    case ProductsIds.VehicleInspectionAndTransferYulCancellation:
    case ProductsIds.VehicleTransferStockCancellation:
    case ProductsIds.VehicleInspectionAndSigningDkpCancellation:
      return ProductIconsNames.VehicleCancellation;
    case ProductsIds.CancellationDefectRecording:
      return ProductIconsNames.CancellationDefectRecording;
    case ProductsIds.PreparationForRepossession:
      return ProductIconsNames.PreparationForRepossession;
    default:
      return ProductIconsNames.NotFoundProduct;
  }
}
